<template>
  <div class="sub-agent-block">
    <div class="links">
      <div class="">

      </div>
      <div v-if="agentInfo" class="">
        Інформація про страхового посередника,
        яка надається клієнту до укладення договору страхування
        відповідно до статті 88 Закону України “Про страхування”

        <section>
          <h3>1. Страховий посередник</h3>
          <ul>
            <li>
              <strong>Повне та скорочене (за наявності) найменування - для юридичної особи та представництва страхового або перестрахового брокера - нерезидента або ПІБ - для фізичної особи та фізичної особи - підприємця: </strong>
              <br>
              <span class="red-class">{{ getFullNameByType(agentInfo) }}</span>
              <br>
              <span class="red-class">{{ agentInfo.recipientTypeId == 1 ? 'ФОП' : '' }} {{ getFullName(agentInfo) }}</span>
            </li>
            <li><strong>Ідентифікаційний код/ ЄДРПОУ:</strong> {{ agentInfo.recipientCode || '' }}</li>
            <li><strong>Місцезнаходження:</strong> {{ getAddress(agentInfo)  }} <!-- м. Київ, вул. Марини Цвєтаєвої, буд. 9А, кв. 195 --></li>
            <li><strong>Адреса вебсайту:</strong> ---</li>
          </ul>
        </section>

        <section>
          <h3>2. Повноваження Страхового посередника</h3>
          <p><strong><span class="red-class">{{ getNamePrefix }} {{ getFullNameWithoutPrefix(agentInfo)  }}</span></strong> є страховим посередником (субагентом), який діє від імені та за дорученням страхового агента</p>
            <ul>
                <li><strong>{{ sourceInfo.name }}<!-- ТОВ "ЮІНШУР" та ТОВ "ПРОІНШУРЕНС" --></strong></li>
                <li><strong>ТОВ «ЮІНШУР»</strong></li>
                <li><strong>Код ЄДРПОУ:</strong> 45581136</li>
                <li><strong>Місцезнаходження:</strong> Україна, 61001, Харківська обл., місто Харків, пр.Героїв Харкова, будинок 57/63, офіс 57</li>
                <li><strong>Вебсайт:</strong> https://uconnect.com.ua</li>
              <li><strong>Поточний рахунок зі спеціальним режимом використання для приймання страхових платежів:</strong> UA663077700000026002211241177</li>
              <li><strong>Реєстраційний номер у Реєстрі посередників НБУ:</strong> 00004153 від 20.03.2025</li>
            </ul>
          <p>  і надає посередницькі послуги з укладення договорів страхування, в тому числі:</p>
          <ul>
            <li>рекламування та/або проведення маркетингових, рекламних та інших підготовчих заходів, спрямованих на укладення Договорів страхування;</li>
            <li>пропонування, пропозиція та консультування Страхувальника щодо укладення Договорів страхування, проведення іншої роботи з підготовки до укладення Договорів страхування;</li>
            <li>укладення Договорів страхування.</li>
          </ul>
        </section>

<!--        <section>-->
<!--          <h3>3. Перелік класів страхування</h3>-->
<!--          <p>Страховий посередник реалізує страхові продукти за наступними класами:</p>-->
<!--          <ul>-->
<!--            <li><strong>Клас 1:</strong> "Страхування від нещасного випадку (в тому числі на випадок виробничої травми та професійного захворювання";</li>-->
<!--            <li><strong>Клас 2:</strong> "Страхування на випадок хвороби (у тому числі медичне страхування)";</li>-->
<!--            <li><strong>Клас 3:</strong> "Страхування наземних транспортних засобів (крім залізничного рухомого складу)";</li>-->
<!--            <li><strong>Клас 10:</strong> "Страхування відповідальності, яка виникає внаслідок використання наземного транспортного засобу (у тому числі відповідальності перевізника)» за ризиком страхування відповідальності власників наземних транспортних засобів, що здійснюється відповідно до Закону України «Про обов'язкове страхування цивільноправової відповідальності власників наземних транспортних засобів";</li>-->
<!--            <li><strong>Клас 13:</strong> "Страхування іншої відповідальності (крім визначеної у класах 10, 11, 12)";</li>-->
<!--            <li><strong>Клас 16:</strong> "Страхування інших фінансових ризиків (крім визначених класами 14, 15)";</li>-->
<!--            <li><strong>Клас 18:</strong> "Страхування витрат, пов’язаних з наданням допомоги (асистанс) особам, які потрапили у скрутне становище під час здійснення подорожі)"</li>-->
<!--          </ul>-->
<!--        </section>-->

        <section>
          <h3>4. Консультації та рекомендації</h3>
          <p><span class="red-class">Страховий посередник</span> надає індивідуальні консультації та рекомендації щодо вибору страхового продукту відповідно до потреб клієнта.<br> Для отримання консультації звертайтесь до служби підтримки на пошту: <strong>{{ agentInfo.email }}</strong> або номер тел.
            <strong>{{ agentInfo.phone }}</strong>.</p>
        </section>

<!--        <section>-->
<!--          <h3>5. Реквізити для сплати страхової премії за договорами страхування на поточний рахунок зі спеціальним режимом використання Страхового посередника:</h3>-->
<!--          <p>Страховий посередник має право отримувати від споживача страхові премії на свій поточний рахунок зі спеціальним режимом використання для цілей зарахування та перерахування страхових премій в спосіб дозволений законодавством України (з урахуванням технічних можливостей страхового посередника)</p>-->
<!--          <p>-->
<!--            <strong>Отримувач:</strong> {{ sourceInfo.name }}&lt;!&ndash; ТОВ "ЮІНШУР" та ТОВ "ПРОІНШУРЕНС" &ndash;&gt;<br>-->
<!--            <strong>ЄДРПОУ:</strong> {{ sourceInfo.edrpy }} &lt;!&ndash; з рахунка&ndash;&gt;<br>-->
<!--            <strong>Рахунок:</strong> {{ sourceInfo.iban }} &lt;!&ndash; в АТ "з рахунка" &ndash;&gt;<br>-->
<!--            <strong>Призначення платежу:</strong> "За страхування, поліс <strong>{{ getMainCode() }}.</strong>"-->
<!--          </p>-->
<!--          <p>Способи здійснення страховим посередником страхових виплат: страховий посередник не здійснює перерахування страхових виплат.</p>-->
<!--        </section>-->

        <section>
          <h3>5. Реєстрація в НБУ</h3>
          <p>Реєстраційний номер у Реєстрі посередників: <strong>{{ agentInfo.nbuNumber }}<!--НОМЕР В РЕЄСТРІ НБУ --></strong> від <strong>{{ agentInfo.nbuDate }}<!-- ДАТА РЕЄСТРАЦІЇ В НБУ --> р.</strong></p>
          <p><a href="https://kis.bank.gov.ua/search-fu" target="_blank">https://kis.bank.gov.ua/search-fu</a> </p>
        </section>

        <section>
          <h3>6. Страхові компанії та продукти, які реалізує Страховий посередник:</h3>
          <table>
            <thead>
            <tr>
<!--              <th>Тип працівника з реалізації страхових продуктів</th>-->
<!--              <th>ПІБ / Суб'єкт</th>-->
<!--              <th>Посада</th>-->
<!--              <th>Діє на підставі договору доручення</th>-->
              <th>Перелік СК та ЄРДПОУ</th>
              <th>Класи страхових продуктів</th>
            </tr>
            </thead>
            <tbody>
            <tr>
<!--              <td>Керівник з реалізації страхових продуктів</td>-->
<!--              <td><span class="red-class">{{ getFullName(agentInfo) }}</span></td>-->
<!--              <td v-if="agentInfo.recipientTypeId == 2">Директор</td>-->
<!--              <td v-else>ФОП</td>-->
<!--              <td>Договори доручення з {{ sourceInfo.name }} <strong>{{ getDogovor() }} </strong>&lt;!&ndash; ТОВ "ЮІНШУР" та ТОВ "ПРОІНШУРЕНС" &ndash;&gt;</td>-->
              <td class="td-first">
                <ul v-if="sourceInfo.sourceTypeId === 1">
                  <li>1. ПУБЛІЧНЕ АКЦІОНЕРНЕ ТОВАРИСТВО «СТРАХОВА КОМПАНІЯ «ЄВРОІНС УКРАЇНА», ЄДРПОУ 22868348, місцезнаходження: 03150, м. Київ, вул. Велика Васильківська, 102.
                    Інформація про послуги страховика: <a href="https://euroins.com.ua/" target="_blank">https://euroins.com.ua/</a>.
                    Посилання на Реєстр: https://kis.bank.gov.ua
                  </li>
                  <li>2. ПРИВАТНЕ АКЦІОНЕРНЕ ТОВАРИСТВО «СТРАХОВА КОМПАНІЯ «ВУСО», ЄДРПОУ 31650052, місцезнаходження: 03150, м. Київ, вул. Казимира Малевича, 31.
                    Інформація про послуги страховика: <a href="https://vuso.ua" target="_blank">https://vuso.ua</a>.
                    Посилання на Реєстр: https://kis.bank.gov.ua
                  </li>
                </ul>
                <ul v-else>
                  <li>1. ПРИВАТНЕ АКЦІОНЕРНЕ ТОВАРИСТВО «СТРАХОВА КОМПАНІЯ «ПЗУ УКРАЇНА», ЄДРПОУ 20782312, місцезнаходження: 04053, м. Київ, вул. Січових Стрільців, 40.
                    Інформація про послуги страховика: <a href="https://www.pzu.com.ua/" target="_blank">https://www.pzu.com.ua/</a>.
                    Посилання на Реєстр: https://kis.bank.gov.ua
                  </li>
                  <li>2. ПРИВАТНЕ АКЦІОНЕРНЕ ТОВАРИСТВО «УКРАЇНСЬКА СТРАХОВА КОМПАНІЯ «КНЯЖА ВІЄННА ІНШУРАНС ГРУП», ЄДРПОУ 24175269, місцезнаходження: 04050, м. Київ, вул. Глибочицька, 44.
                    Інформація про послуги страховика: <a href="https://kniazha.ua/" target="_blank">https://kniazha.ua/</a>.
                    Посилання на Реєстр: https://kis.bank.gov.ua
                  </li>
                  <li>3. АКЦІОНЕРНЕ ТОВАРИСТВО «СТРАХОВА КОМПАНІЯ «АРКС», ЄДРПОУ 20474912, місцезнаходження: 04070, м. Київ, вул. Іллінська, 8.
                    Інформація про послуги страховика: <a href="https://arx.com.ua/" target="_blank">https://arx.com.ua/</a>.
                    Посилання на Реєстр: https://kis.bank.gov.ua
                  </li>
                  <li>4. АКЦІОНЕРНЕ ТОВАРИСТВО «СТРАХОВА КОМПАНІЯ «ББС ІНШУРАНС», ЄДРПОУ 20344871, місцезнаходження: 04050, м. Київ, вул. Білоруська, 3.
                    Інформація про послуги страховика: <a href="http://bbs.ua/" target="_blank">http://bbs.ua/</a>.
                    Посилання на Реєстр: https://kis.bank.gov.ua
                  </li>
                  <li>5. ТОВАРИСТВО З ДОДАТКОВОЮ ВІДПОВІДАЛЬНІСТЮ «ЕКСПРЕС СТРАХУВАННЯ», ЄДРПОУ 36086124, місцезнаходження: 04073, м. Київ, проспект Степана Бандери, 28-А.
                    Інформація про послуги страховика: <a href="https://www.express-insurance.com.ua/" target="_blank">https://www.express-insurance.com.ua/</a>.
                    Посилання на Реєстр: https://kis.bank.gov.ua
                  </li>
                  <li>6. ПУБЛІЧНЕ АКЦІОНЕРНЕ ТОВАРИСТВО «НАЦІОНАЛЬНА АКЦІОНЕРНА СТРАХОВА КОМПАНІЯ «ОРАНТА», ЄДРПОУ 00034186, місцезнаходження: 02081, м. Київ, вул. Здолбунівська, 7-Д.
                    Інформація про послуги страховика: <a href="https://oranta.ua/" target="_blank">https://oranta.ua/</a>.
                    Посилання на Реєстр: https://kis.bank.gov.ua
                  </li>
                  <li>7. ПУБЛІЧНЕ АКЦІОНЕРНЕ ТОВАРИСТВО «СТРАХОВА ГРУПА «ТАС», ЄДРПОУ 30115243, місцезнаходження: 03117, м. Київ, проспект Берестейський, 65.
                    Інформація про послуги страховика: <a href="https://tas-insurance.com.ua" target="_blank">https://tas-insurance.com.ua</a>.
                    Посилання на Реєстр: https://kis.bank.gov.ua
                  </li>
                  <li>8. ПУБЛІЧНЕ АКЦІОНЕРНЕ ТОВАРИСТВО «СТРАХОВА КОМПАНІЯ «ЄВРОІНС УКРАЇНА», ЄДРПОУ 22868348, місцезнаходження: 03150, м. Київ, вул. Велика Васильківська, 102.
                    Інформація про послуги страховика: <a href="https://euroins.com.ua/" target="_blank">https://euroins.com.ua/</a>.
                    Посилання на Реєстр: https://kis.bank.gov.ua
                  </li>
                  <li>9. ПРИВАТНЕ АКЦІОНЕРНЕ ТОВАРИСТВО «УКРАЇНСЬКА ТРАНСПОРТНА СТРАХОВА КОМПАНІЯ», ЄДРПОУ 22945712, місцезнаходження: 04071, м. Київ, вул. Ярославська, 58.
                    Інформація про послуги страховика: <a href="https://www.utico.ua/" target="_blank">https://www.utico.ua/</a>.
                    Посилання на Реєстр: https://kis.bank.gov.ua
                  </li>
                  <li>10. ПУБЛІЧНЕ АКЦІОНЕРНЕ ТОВАРИСТВО «СТРАХОВА КОМПАНІЯ «ІНТЕР-ПОЛІС», ЄДРПОУ 19350062, місцезнаходження: 04050, м. Київ, вул. Білоруська, 3.
                    Інформація про послуги страховика: <a href="https://www.inter-policy.com" target="_blank">https://www.inter-policy.com</a>.
                    Посилання на Реєстр: https://kis.bank.gov.ua
                  </li>
                  <li>11. АКЦІОНЕРНЕ ТОВАРИСТВО «СТРАХОВА КОМПАНІЯ «ІНГО», ЄДРПОУ 16285602, місцезнаходження: 01054, м. Київ, вул. Бульварно-Кудрявська, 33.
                    Інформація про послуги страховика: <a href="https://ingo.ua/" target="_blank">https://ingo.ua/</a>.
                    Посилання на Реєстр: https://kis.bank.gov.ua
                  </li>
                  <li>12. ПРИВАТНЕ АКЦІОНЕРНЕ ТОВАРИСТВО «СТРАХОВА КОМПАНІЯ «ВУСО», ЄДРПОУ 31650052, місцезнаходження: 03150, м. Київ, вул. Казимира Малевича, 31.
                    Інформація про послуги страховика: <a href="https://vuso.ua" target="_blank">https://vuso.ua</a>.
                    Посилання на Реєстр: https://kis.bank.gov.ua
                  </li>
                  <li>13. ПРИВАТНЕ АКЦІОНЕРНЕ ТОВАРИСТВО «СТРАХОВА КОМПАНІЯ «АРСЕНАЛ СТРАХУВАННЯ», ЄДРПОУ 33908322, місцезнаходження: 03056, м. Київ, вул. Борщагівська, 154.
                    Інформація про послуги страховика: <a href="https://arsenal-ic.ua/" target="_blank">https://arsenal-ic.ua/</a>.
                    Посилання на Реєстр: https://kis.bank.gov.ua
                  </li>
                  <li>14. ПРИВАТНЕ АКЦІОНЕРНЕ ТОВАРИСТВО «СТРАХОВА КОМПАНІЯ «УСГ», ЄДРПОУ 30859524, місцезнаходження: 03038, м. Київ, вул. Івана Федорова, 32-А.
                    Інформація про послуги страховика: <a href="https://www.usg.ua/" target="_blank">https://www.usg.ua/</a>.
                    Посилання на Реєстр: https://kis.bank.gov.ua
                  </li>
                  <li>15. ПРИВАТНЕ АКЦІОНЕРНЕ ТОВАРИСТВО «ЄВРОПЕЙСЬКЕ ТУРИСТИЧНЕ СТРАХУВАННЯ», ЄДРПОУ 34692526, місцезнаходження: 04071, м. Київ, вул. Спаська, 5.
                    Інформація про послуги страховика: <a href="https://eurotravelins.com.ua/" target="_blank">https://eurotravelins.com.ua/</a>.
                    Посилання на Реєстр: https://kis.bank.gov.ua
                  </li>
                  <li>16. ПРИВАТНЕ АКЦІОНЕРНЕ ТОВАРИСТВО «СТРАХОВА КОМПАНІЯ «УНІКА», ЄДРПОУ 20033533, місцезнаходження: 04112, м. Київ, вул. Олени Теліги, 6, літ. В.
                    Інформація про послуги страховика: <a href="https://uniqa.ua/" target="_blank">https://uniqa.ua/</a>.
                    Посилання на Реєстр: https://kis.bank.gov.ua
                  </li>
                  <li>17. ПРИВАТНЕ АКЦІОНЕРНЕ ТОВАРИСТВО «ІННОВАЦІЙНИЙ СТРАХОВИЙ КАПІТАЛ», ЄДРПОУ 32942598, місцезнаходження: 04080, м. Київ, вул. Кирилівська, 40.
                    Інформація про послуги страховика: <a href="https://insk.com.ua/ua/" target="_blank">https://insk.com.ua/ua/</a>.
                    Посилання на Реєстр: https://kis.bank.gov.ua
                  </li>
                  <li>18. ТОВАРИСТВО З ДОДАТКОВОЮ ВІДПОВІДАЛЬНІСТЮ СТРАХОВА КОМПАНІЯ «ГАРДІАН», ЄДРПОУ 35417298, місцезнаходження: 01032, м. Київ, вул. Саксаганського, 96.
                    Інформація про послуги страховика: <a href="https://grdn.com.ua/" target="_blank">https://grdn.com.ua/</a>.
                    Посилання на Реєстр: https://kis.bank.gov.ua
                  </li>
                  <li>19. ПРИВАТНЕ АКЦІОНЕРНЕ ТОВАРИСТВО «ЄВРОПЕЙСЬКИЙ СТРАХОВИЙ АЛЬЯНС», ЄДРПОУ 19411125, місцезнаходження: 03039, м. Київ, проспект Валерія Лобановського, 17.
                    Інформація про послуги страховика: <a href="https://eia.com.ua/" target="_blank">https://eia.com.ua/</a>.
                    Посилання на Реєстр: https://kis.bank.gov.ua
                  </li>
                </ul>
              </td>
              <td class="td-second">
                <ul>
                  <li>Клас 1 «Страхування від нещасного випадку (в тому числі на випадок виробничої травми та професійного захворювання»;</li>
                  <li>Клас 2 «Страхування на випадок хвороби (у тому числі медичне страхування)»;</li>
                  <li>Клас 3 «Страхування наземних транспортних засобів (крім залізничного рухомого складу)»;</li>
                  <li>Клас 10 «Страхування відповідальності, яка виникає внаслідок використання наземного транспортного засобу (у тому числі відповідальності перевізника)» страхування відповідальності власників наземних транспортних засобів, що здійснюється відповідно до Закону України «Про обов'язкове страхування цивільноправової відповідальності власників наземних транспортних засобів»;</li>
                  <li>Клас 13 «Страхування іншої відповідальності (крім визначеної у класах 10, 11, 12)»;</li>
                  <li>Клас 16 «Страхування інших фінансових ризиків (крім визначених класами 14, 15)»;</li>
                  <li>Клас 18 «Страхування витрат, пов’язаних з наданням допомоги (асистанс) особам, які потрапили у скрутне становище під час здійснення подорожі)»</li>
                </ul>
              </td>
            </tr>
            </tbody>
          </table>
        </section>

        <section>
          <h3>7. Наявність істотної участі в будь-якому страховику та страховому посереднику</h3>
          <p><strong>{{ getNamePrefix }} {{ getFullNameWithoutPrefix(agentInfo)  }}</strong> не має істотної участі в будь-якому зі страховиків та страхових посередників.</p>
        </section>

        <section>
          <h3>8. Наявність істотної участі страховика у страховому посереднику</h3>
          <p>Будь-який страховик не має істотної участі в <strong>{{ getNamePrefix }} {{ getFullNameWithoutPrefix(agentInfo) }}</strong> </p>
        </section>

        <section>
          <h3>9. Перелік відокремлених підрозділів страхового посередника, в яких споживач може укласти договір страхування (за наявності)</h3>
          <p>Відокремлені підрозділи відсутні</p>
        </section>

        <section>
          <h3>10. Вид винагороди за укладення договору страхування, порядок та умови її виплати</h3>
          <p>За укладання договорів страхування субагент отримує комісійну винагороду у розмірі фіксованого відсотка від страхової премії за договором страхування (винагорода входить до складу страхової премії). Винагороду страховому субагенту сплачує страховий агент.</p>
        </section>

        <section>
          <h3>11. Розмір та спосіб оплати послуг субагента безпосередньо клієнтом</h3>
          <p>Клієнт не оплачує послуги субагента.</p>
        </section>

        <section>
          <h3>12. Будь-які інші платежі (крім страхової премії), які клієнт зобов’язаний сплатити відповідно до умов договору страхування після його укладення</h3>
          <p>Будь-які інші платежі (крім страхової премії) Клієнт не повинен сплачувати відповідно до умов договору страхування після його укладення.</p>
        </section>

        <section>
          <h3>13. Інформація про механізми та способи захисту прав</h3>
          <p>
            Страховий посередник дотримується вимог Закону України «Про захист персональних даних» та внутрішніх нормативних документів страховика щодо обробки та захисту персональних даних споживачів фінансових послуг.
          </p>
          <p>
            Звернення розглядаються і вирішуються Страховиком у термін не більше одного місяця від дня їх надходження, а ті, які не потребують додаткового вивчення, - не пізніше п'ятнадцяти днів від дня їх отримання.
          </p>
          <p>
            Якщо в місячний термін вирішити порушені у зверненні питання неможливо, уповноважена особа Страховика встановлює необхідний термін для його розгляду, що не може перевищувати сорока п'яти днів.
          </p>
          <p>
            Звернення може бути усним за допомогою засобів телефонного зв’язку через контактний центр Страховика та/або страхового субагента чи письмовим на електронну пошту Страховика або засобами поштового зв’язку на його адресу.
          </p>
          <p>
            Скарга на дії чи рішення Страховика подається у порядку підлеглості:
          </p>
          <ul>
            <li><strong>Національному банку України:</strong> (на електронну пошту nbu@bank.gov.ua, використовуючи спеціальну форму <a href="https://bank.gov.ua/ua/consumer-protection">https://bank.gov.ua/ua/consumer-protection</a>; або на адресу: 01601, м. Київ, вул. Інститутська, 9, тел: <strong>0 800 505 240);</strong></a></li>
            <li><strong>до Державної служби України з питань безпечності харчових продуктів та захисту споживачів:</strong> (адреса: 01001, м. Київ, вул. Б.Грінченка, 1, тел. <strong>(044) 279 12 70</strong>, e-mail: <strong>info@dpss.gov.ua)</strong>.</li>
          </ul>
          <div class="important-note">
            Подання скарги не позбавляє вас права звернутися безпосередньо до суду.
          </div>
        </section>
      </div>
    </div>
  </div>

</template>


<script>
    import Vue from "vue";
    import ClientPropositionsBlock from '@/views/links/clientPropositionsBlock.vue';
    import Pagination from '@/components/Pagination';
    import {showLink, saveLink, getSubAgentInfo} from "@/api/link";
    const FileDownload = require('js-file-download');

    export default {
        components: {
            Pagination,
            ClientPropositionsBlock,
        },
        data: function () {
            return {
                mobileWith: 992,
                agentInfo: null,
                sourceInfo: null,
                orderInfo: null,
                agentType: 1,
                condition: {
                    isLoadTable: true,
                    isMobile: false,
                },
                listQuery: {
                    page: 1,
                    limit: 10,
                }
            }
        },
        created: function() {
            window.addEventListener("resize", this.checkWindowResize);
            this.checkIsMobile();
        },
        mounted: function() { // The hook. Here, Vue has already worked its magic.
            this.initLinkData();
        },
        computed:{
          getNamePrefix() {
            let prefix = '';
            if (this.agentInfo.recipientTypeId == 1) {
              prefix = 'ФОП';
            } else if (this.agentInfo.recipientTypeId == 2) {
              prefix = 'ТОВ';
            }
            return prefix
          },
        },
        methods: {
            initLinkData: async function() {
                getSubAgentInfo(this.$route.query).then(response => {
                  const { data } = response;
                  this.agentInfo = data?.data?.userInfo;
                  this.agentType = data?.data?.userInfo?.typeId;
                  this.sourceInfo = data?.data?.sourceInfo;
                  this.orderInfo = data?.data?.orderInfo;
                });

            },
            getMainCode() {
                return this.orderInfo.data?.mtsbu_code ?? this.orderInfo.data?.mainCode ?? '';
            },
            getAddress() {
                const city = this.agentInfo.city?.name_ua ?? '';
                const street = this.agentInfo.street ? 'вул. ' + this.agentInfo.street : '';
                const house = this.agentInfo.house ? ', буд. ' + this.agentInfo.house : '';
                const apartment = this.agentInfo.apartment ? ', кв. ' + this.agentInfo.apartment : '';
                return (city ? city + ', ' : '') + street + house + apartment;
            },
            getFullName() {
              return this.agentInfo?.recipientName ?? (this.agentInfo?.surname ?? '') + ' ' + (this.agentInfo?.name ?? '') + ' ' + (this.agentInfo?.patronymic ?? '');
            },
            getFullNameByType() {
              let fullName = this.agentInfo?.recipientName ?? (this.agentInfo?.surname ?? '') + ' ' + (this.agentInfo?.name ?? '') + ' ' + (this.agentInfo?.patronymic ?? '');

              fullName = fullName.replaceAll("ТОВ", "");
              fullName = fullName.replaceAll("ФОП", "");
             // const regex = /\b(ТОВ|ФОП)/g;//\b
             // fullName = fullName.replaceAll(regex, "").replace(/\s+/g, " ").trim();

              const fullNameByType = this.agentInfo.recipientTypeId == 1 ?
                ( 'Фізична особа підприємець ' + fullName) :
                ( 'Товариство з обмеженою відповідальністю ' + fullName);

              return fullNameByType;
            },
            getFullNameWithoutPrefix() {
              const fopTov = ["ТОВ", "ФОП"];
              let fullName = this.agentInfo?.recipientName ?? (this.agentInfo?.surname ?? '') + ' ' + (this.agentInfo?.name ?? '') + ' ' + (this.agentInfo?.patronymic ?? '');

              let nameWithoutPrefix = fullName.replaceAll("ТОВ", "");
              nameWithoutPrefix = nameWithoutPrefix.replaceAll("ФОП", "");

              return nameWithoutPrefix;
            },

            getDogovor(sourceInfo) {
              return this.sourceInfo.sourceTypeId === 1 ? this.agentInfo.contractNumberProinsurance : this.agentInfo.contractNumberUinsure;
            },
            isLinkClientProposition: function () {
                return this.linkType == 1;
            },
            isLinkPenalty: function () {
                return this.linkType == 2;
            },
            checkIsMobile: function() {
                return this.condition.isMobile = window.innerWidth < this.mobileWith;
            },
            checkWindowResize: function() {
                this.checkIsMobile()
            },
        },
        destroyed() {
            window.removeEventListener("resize", this.checkWindowResize);
        },
    }
</script>

<style>
body { font-family: sans-serif; line-height: 1.6; color: #333; max-width: 1600px; margin: 20px auto; padding: 80px 20px; }
h2 { color: #2c3e50; border-bottom: 2px solid #eee; padding-bottom: 10px; }
h3 { color: #2980b9; margin-top: 25px; }
ul { padding-left: 20px; }
li { margin-bottom: 8px; }
table { width: 100%; border-collapse: collapse; margin: 20px 0; }
th, td { border: 1px solid #ddd; padding: 12px; text-align: left; }
.td-first {
  width: 60%;
}
th { background-color: #f8f9fa; }
.important-note { background-color: #fff3cd; padding: 15px; border-left: 5px solid #ffeeba; margin: 20px 0; }
</style>
